import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'

import modalStyle from '../../../_common/core/modalStyle'
import { GENERATE_API_KEY, GET_API_KEY } from '../../../_common/redux/auth/actions'

import Card from '../../_library/Card'
import Clipboard from '../../_library/Clipboard'
import Button from '../../_library/Button'
import { showAxiosError, showMessage } from '../../utils/messenger'

const ApiKeySectionComponent = ({ GET_API_KEY, apiKey, isLoadingApiKey, GENERATE_API_KEY }) => {
  const [showRegenerateApiKeyModal, setModalOpen] = useState(false)

  const hasApiKey = Boolean(apiKey)

  useEffect(() => {
    if (!apiKey) {
      GET_API_KEY()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiKey])

  const generateApiKey = async () => {
    try {
      await GENERATE_API_KEY()
      showMessage('success', 'API Key Generated', 3)
    } catch (error) {
      showAxiosError(error)
    }
    setModalOpen(false)
  }

  return (
    <Card icon={'fa fa-key'} title={'API Key'}>
      {!hasApiKey && !isLoadingApiKey && (
        <div className="col-xs-12 text-center padding-bottom10">
          <p>Create your API key to connect with our API.</p>
          <button type="button" className="btn btn-default btn-shadow" onClick={generateApiKey}>
            Generate API Key
          </button>
        </div>
      )}
      {!hasApiKey && isLoadingApiKey && (
        <div className="col-xs-12 text-center padding-bottom10">
          <i className="fa fa-spin fa-spinner" />
          Loading...
        </div>
      )}
      {hasApiKey && (
        <div className="row">
          <div className="col-xs-12">
            <label>Use the Api key below to allow your application to integrate with our API.</label>
            <div className={'wrapper-api-key-box'}>
              <div aria-hidden onClick={() => {}} className="wrapper-api-key">
                <div className="api-key-prefix-url" style={{ display: 'flex', flexDirection: 'row' }}>
                  {apiKey}
                  <Clipboard containerStyle={{ marginLeft: 10 }} text={apiKey} />
                </div>
              </div>
              <div className="generic-buttons-box">
                <Button
                  className="btn btn-default btn-shadow"
                  type="button"
                  disabled={false}
                  onClick={() => {
                    setModalOpen(true)
                  }}
                >
                  <i className="fa fa-undo" /> Regenerate
                </Button>
                <Modal
                  className=" modal-trans"
                  style={modalStyle}
                  isOpen={showRegenerateApiKeyModal}
                  contentLabel="Modal"
                  onRequestClose={() => {}}
                  closeTimeoutMS={150}
                  ariaHideApp={false}
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">Confirm</div>
                      <div className="modal-body">
                        Regenerating the api key will invalidate previous api keys and may require to
                        reauthenticate in the application it was used on.
                      </div>
                      <div className="modal-footer">
                        <div className="btn-toolbar btn-toolbar-right">
                          <Button
                            className="btn btn-success btn-shadow"
                            type="button"
                            onClick={generateApiKey}
                          >
                            Regenerate
                          </Button>
                          <Button
                            className="btn btn-default btn-shadow"
                            type="button"
                            onClick={() => {
                              setModalOpen(false)
                            }}
                          >
                            Go back
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      )}
    </Card>
  )
}

const mapStateToProps = state => {
  const isLoadingApiKey = state.loading.has('GET_API_KEY')
  const { apiKey } = state.auth

  return { isLoadingApiKey, apiKey }
}

const ApiKeySectionNew = connect(mapStateToProps, { GET_API_KEY, GENERATE_API_KEY })(ApiKeySectionComponent)

export default ApiKeySectionNew
